import About from "../pages/about";
import Cart from "../pages/shop/Cart";
import Dashboard from "../pages/home";
import Courses from "../pages/courses";
import Services from "../pages/service";
import SparkRule from "../pages/sparkRule";
import Gallery from "../pages/more/Gallery";
import ContactUs from "../pages/Contact Us";
import Profile from "../pages/User/Profile";
import Products from "../pages/shop/Product";
import Checkout from "../pages/shop/Checkout";
import MyOrders from "../pages/User/MyOrders";
import Partners from "../pages/more/parterners";
import LandingPage from "../pages/landing page";
import MyAccount from "../pages/User/MyAccount";
import ThankyouPage from "../pages/shop/Thankyou";
import Soldering from "../pages/lessons/Soldering";
import EditProfile from "../pages/User/EditProfile";
import OrderCancel from "../pages/shop/OrderCancel";
import AddressDetail from "../pages/User/AddressDetail";
import ProductDetail from "../pages/shop/ProductDetail";
import TeamDirectory from "../pages/more/Team Directory";
import ThreeDModling from "../pages/lessons/3D modeling";
import Fusion from "../pages/lessons/3D modeling/Fusion";
import ForgotPassword from "../pages/User/ForgotPassword";
import ThreeDPrinting from "../pages/lessons/3D Printing";
import Slicing from "../pages/lessons/3D Printing/Slicing";
import ServiceDetail from "../pages/service/ServiceDetail";
import LeagueTournament from "../pages/getStarted/leagues";
import WeaponPhysics from "../pages/lessons/Weapon Physics";
import PrivacyPolicy from "../pages/more/Privacy and Policy";
import GlossaryOfTerms from "../pages/more/Glossary of Terms";
import Tinkercad from "../pages/lessons/3D modeling/Tinkercad";
import ToolsOfTheTrade from "../pages/more/Tools of the Trade";
import PCBS from "../pages/lessons/electrical engineering/PCBs";
import GoodKidsToStart from "../pages/getStarted/goodKitsToStart";
import ClassroomInvitations from "../pages/classroom invitations";
import EventCoverageResults from "../pages/more/Event Coverage Results";
import Receivers from "../pages/lessons/electrical engineering/Receivers";
import Batteries from "../pages/lessons/electrical engineering/Batteries";
import ElectricalEngineering from "../pages/lessons/electrical engineering";
import ESCs_BESCs from "../pages/lessons/electrical engineering/ESCs BESCs";
import GearRatiosAndMechanisms from "../pages/lessons/Gear ratios and mechanisms";
import MaterialScience from "../pages/lessons/Materials Science and Robot Combat";
import Antweights from "../pages/Weight Class-Specific Info. and tips/Antweights";
import BrushedVsBrushlessMotors from "../pages/lessons/Brushed vs. brushless motors";
import Fairyweights from "../pages/Weight Class-Specific Info. and tips/Fairyweights";
import PhysicsAndGeoMetry from "../pages/lessons/Physics, Geometry, and Robot Combat";
import Hobbyweights from "../pages/Weight Class-Specific Info. and tips/Hobbyweights";
import Beetleweights from "../pages/Weight Class-Specific Info. and tips/Beetleweights";
import Sportsmans from "../pages/Weight Class-Specific Info. and tips/Sportsmans (30lb.)";
import PlasticAntweights from "../pages/Weight Class-Specific Info. and tips/Plastic Antweights";
import Featherweights from "../pages/Weight Class-Specific Info. and tips/Featherweights (30lb.)";
import WeightClassesRestrictions from "../pages/getStarted/thingsToKnow/WeightClassesRestrictions";
import Login from "../pages/authentication/Login";
import AuthCheck from "../pages/authentication/authCheck";
import MemberLogin from "../pages/User/MemberLogin";
import Lexicon from "../pages/lexicon";
import EventDetail from "../pages/more/Event Coverage Results/EventDetail";
import TeamMemberDetail from "../pages/more/Team Directory/TeamDetail";
import BotDirectory from "../pages/more/bot directory";
import Curriculum from "../pages/curriculum";
import LexiconDynamicPage from "../pages/lexicon dynamic page";
import Testing from "../pages/lexicon/Testing";
import Pricing from "../pages/curriculum/pricing";
import CheckoutToPay from "../pages/curriculum/checkout";
import MediaContent from "../pages/media content";
export const pageRoutes = {
  mediaContent: "/media-content",
  pricing: "/pricing",
  checkoutToPay: "/checkoutToPay",
  knowledgebaseDynamicPages: "/knowledgebase/:routeName",
  testing: "/embeded-docs/slides",
  battleBots: "/knowledgebase/battlebots",
  controlBots: "/knowledgebase/controlbots",
  drumSpinners: "/knowledgebase/drumspinners",
  fliperBots: "/knowledgebase/fliper-bots",
  firebots: "/knowledgebase/firebots",
  gearboxes: "/knowledgebase/gearboxes",
  hammerbots: "/knowledgebase/hammerbots",
  handTools: "/knowledgebase/handTools",
  horizontalSpinners: "/knowledgebase/horizontal-spinners",
  modesOfTransferringMotion: "/knowledgebase/modes-of-transferring-motion",
  nhrl: "/knowledgebase/nhrl",
  overheadSaws: "/knowledgebase/overheadSaws",
  plants: "/knowledgebase/plants",
  powerTools: "/knowledgebase/power-tools",
  printedCircuitBoards: "/knowledgebase/printed-circuit-boards",
  rcl: "/knowledgebase/rcl",
  ssp: "/knowledgebase/ssp",
  turnabots: "/knowledgebase/turnabots",
  typesOfDriveSystem: "/knowledgebase/types-of-drive-system",
  verticalSpinners: "/knowledgebase/vertical-spinners",
  driveSystems: "/knowledgebase/drive-systems",
  weaponsSystems: "/knowledgebase/weapons-systems",
  lexicon: "/knowledgebase",
  Curriculum: "/Curriculum",
  teamDetail: "/team-detail",
  botDirectory: "/bot-directory",
  eventDetail: "/event-detail",
  authcheck: "/authcheck",
  // landingPage: "/",
  classroomInvitations: "/class-invitations",
  courses: "/courses",
  home: "/",
  getStarted: {
    leaguesTournaments: "/leagues-tournaments",
    goodKidsToStart: "/good-kits-to-start-with",
    thingsToKnowBefore: {
      weightClassesRestrictions: "/weight-classes-restrictions",
    },
  },
  sparcRule: "/spark-rule",
  lessons: {
    electricalEngineering: "/electrical-engineering",
    electricalEngineeringMenu: {
      pcbs: "/pcbs",
      escs_bescs: "/ecbs-pcbs",
      batteries: "/batteries",
      receivers: "/Receivers",
    },
    physicsAndGeoMetry: "/physics-GeoMetry",
    materialScience: "/materialscience",
    soldering: "/soldering",
    brushedVsBrushlessMotors: "/brushed-vs-brushless-motors",
    weaponPhysics: "/weapon-physics",
    gearRatiosAndMechanisms: "/gear-ratios-and-mechanisms",
    threeDModling: "/3dmodling",
    threeDModlingMenu: {
      tinkercad: "/tinkercad",
      fusion: "/fusion",
    },
    threeDPrinting: "/3printing",
    threeDPrintingMenu: {
      slicing: "/slicing",
    },
  },
  weightClassSpecificInfo: {
    fairyweights: "/fairyweights",
    plasticAntweights: "/plastic-antweights",
    antweights: "/antweights",
    beetleweights: "/beetleweights",
    hobbyweights: "/hobbyweights",
    featherweights: "/featherweights",
    sportsmans: "/sportsmans",
  },
  more: {
    partners: "/partners",
    toolsOfTheTrade: "/tools-of-the-trade",
    eventCoverageResults: "/event-coverage-results",
    teamDirectory: "/team-directory",
    teamDirectoryRegisterLogin: "/member-login-register",
    robotDirectory: "/robot-directory",
    glossaryOfTerms: "/terms-and-conditions",
    gallery: "/gallery",
  },
  login: "/login",
  myAccount: "/dashboard",
  myOrders: "/my-order",
  profile: "/profile",
  editProfile: "/edit-profile",
  addressDetail: "/addressDetail",
  shop: {
    products: "/products",
    productDetails: "/product-details",
    orderCancel: "/order-cancel",
    thankyouPage: "/order-success",
  },
  cart: "/cart",
  checkout: "/checkout",
  about: "/about",
  forgotPassword: "/forgot-password",
  services: "/services",
  serviceDetail: "/service-detail",
  privacyPolicy: "/privacy-policy",
  contactUs: "/contact-us",
  teacherPanelRedirection: "https://robotcombat101.com/teacher/",
  studentPanelLoginRedirection: "https://robotcombat101.com/login",
  loginPageRedirectLink: "https://robotcombat101.com/teacher/login",
};

export const AllRoutes = [
  {
    name: "MediaContent",
    path: pageRoutes.mediaContent,
    element: <MediaContent />,
    isPrivate: false,
  },
  {
    name: "checkoutToPay",
    path: pageRoutes.checkoutToPay,
    element: <CheckoutToPay />,
    isPrivate: false,
  },
  {
    name: "BotDirectory",
    path: pageRoutes.botDirectory,
    element: <BotDirectory />,
    isPrivate: false,
  },
  {
    name: "Pricing",
    path: pageRoutes.pricing,
    element: <Pricing />,
    isPrivate: false,
  },
  {
    name: "testing",
    path: pageRoutes.testing,
    element: <Testing />,
    isPrivate: false,
  },
  {
    name: "knowledgebaseDynamicPages",
    path: pageRoutes.knowledgebaseDynamicPages,
    element: <LexiconDynamicPage />,
    isPrivate: false,
  },
  {
    name: "eventDetail",
    path: pageRoutes.eventDetail,
    element: <EventDetail />,
    isPrivate: false,
  },
  {
    name: "TeamMemberDetail",
    path: pageRoutes.teamDetail,
    element: <TeamMemberDetail />,
    isPrivate: false,
  },
  {
    name: "ClassroomInvitations",
    path: pageRoutes.classroomInvitations,
    element: <ClassroomInvitations />,
    isPrivate: true,
  },
  {
    name: "Lexicon",
    path: pageRoutes.lexicon,
    element: <Lexicon />,
    isPrivate: false,
  },
  {
    name: "Courses",
    path: pageRoutes.courses,
    element: <Courses />,
    isPrivate: true,
  },
  // {
  //   name: "landingPage",
  //   path: pageRoutes.landingPage,
  //   element: <LandingPage />,
  //   isPrivate: false,
  // },
  {
    name: "Dashboard",
    path: pageRoutes.home,
    element: <Dashboard />,
    isPrivate: false,
  },
  {
    name: "LeagueTournament",
    path: pageRoutes.getStarted?.leaguesTournaments,
    element: <LeagueTournament />,
    isPrivate: false,
  },
  {
    name: "GoodKidsToStart",
    path: pageRoutes.getStarted?.goodKidsToStart,
    element: <GoodKidsToStart />,
    isPrivate: false,
  },
  {
    name: "WeightClassesRestrictions",
    path: pageRoutes.getStarted?.thingsToKnowBefore?.weightClassesRestrictions,
    element: <WeightClassesRestrictions />,
    isPrivate: false,
  },
  {
    name: "SparkRule",
    path: pageRoutes.sparcRule,
    element: <SparkRule />,
    isPrivate: false,
  },
  {
    name: "ElectricalEngineering",
    path: pageRoutes.lessons?.electricalEngineering,
    element: <ElectricalEngineering />,
    isPrivate: false,
  },
  {
    name: "PCBS",
    path: pageRoutes.lessons?.electricalEngineeringMenu?.pcbs,
    element: <PCBS />,
    isPrivate: false,
  },
  {
    name: "ESCs_BESCs",
    path: pageRoutes.lessons?.electricalEngineeringMenu?.escs_bescs,
    element: <ESCs_BESCs />,
    isPrivate: false,
  },
  {
    name: "Batteries",
    path: pageRoutes.lessons?.electricalEngineeringMenu?.batteries,
    element: <Batteries />,
    isPrivate: false,
  },
  {
    name: "Receivers",
    path: pageRoutes.lessons?.electricalEngineeringMenu?.receivers,
    element: <Receivers />,
    isPrivate: false,
  },
  {
    name: "PhysicsAndGeoMetry",
    path: pageRoutes.lessons?.physicsAndGeoMetry,
    element: <PhysicsAndGeoMetry />,
    isPrivate: false,
  },
  {
    name: "MaterialScience",
    path: pageRoutes.lessons?.materialScience,
    element: <MaterialScience />,
    isPrivate: false,
  },
  {
    name: "Soldering",
    path: pageRoutes.lessons?.soldering,
    element: <Soldering />,
    isPrivate: false,
  },
  {
    name: "BrushedVsBrushlessMotors",
    path: pageRoutes.lessons?.brushedVsBrushlessMotors,
    element: <BrushedVsBrushlessMotors />,
    isPrivate: false,
  },
  {
    name: "WeaponPhysics",
    path: pageRoutes.lessons?.weaponPhysics,
    element: <WeaponPhysics />,
    isPrivate: false,
  },
  {
    name: "GearRatiosAndMechanisms",
    path: pageRoutes.lessons?.gearRatiosAndMechanisms,
    element: <GearRatiosAndMechanisms />,
    isPrivate: false,
  },
  {
    name: "ThreeDModling",
    path: pageRoutes.lessons?.threeDModling,
    element: <ThreeDModling />,
    isPrivate: false,
  },
  {
    name: "Tinkercad",
    path: pageRoutes.lessons?.threeDModlingMenu?.tinkercad,
    element: <Tinkercad />,
    isPrivate: false,
  },
  {
    name: "Fusion",
    path: pageRoutes.lessons?.threeDModlingMenu?.fusion,
    element: <Fusion />,
    isPrivate: false,
  },
  {
    name: "ThreeDPrinting",
    path: pageRoutes.lessons?.threeDPrinting,
    element: <ThreeDPrinting />,
    isPrivate: false,
  },
  {
    name: "Slicing",
    path: pageRoutes.lessons?.threeDPrintingMenu?.slicing,
    element: <Slicing />,
    isPrivate: false,
  },
  {
    name: "Fairyweights",
    path: pageRoutes.weightClassSpecificInfo?.fairyweights,
    element: <Fairyweights />,
    isPrivate: false,
  },
  {
    name: "PlasticAntweights",
    path: pageRoutes.weightClassSpecificInfo?.plasticAntweights,
    element: <PlasticAntweights />,
    isPrivate: false,
  },
  {
    name: "Antweights",
    path: pageRoutes.weightClassSpecificInfo?.antweights,
    element: <Antweights />,
    isPrivate: false,
  },
  {
    name: "Beetleweights",
    path: pageRoutes.weightClassSpecificInfo?.beetleweights,
    element: <Beetleweights />,
    isPrivate: false,
  },
  {
    name: "Hobbyweights",
    path: pageRoutes.weightClassSpecificInfo?.hobbyweights,
    element: <Hobbyweights />,
    isPrivate: false,
  },
  {
    name: "Featherweights",
    path: pageRoutes.weightClassSpecificInfo?.featherweights,
    element: <Featherweights />,
    isPrivate: false,
  },
  {
    name: "Sportsmans",
    path: pageRoutes.weightClassSpecificInfo?.sportsmans,
    element: <Sportsmans />,
    isPrivate: false,
  },
  {
    name: "Partners",
    path: pageRoutes.more?.partners,
    element: <Partners />,
    isPrivate: false,
  },
  {
    name: "ToolsOfTheTrade",
    path: pageRoutes.more?.toolsOfTheTrade,
    element: <ToolsOfTheTrade />,
    isPrivate: false,
  },
  {
    name: "EventCoverageResults",
    path: pageRoutes.more?.eventCoverageResults,
    element: <EventCoverageResults />,
    isPrivate: false,
  },
  {
    name: "TeamDirectory",
    path: pageRoutes.more?.teamDirectory,
    element: <TeamDirectory />,
    isPrivate: false,
  },
  {
    name: "teamDirectoryRegisterLogin",
    path: pageRoutes.more?.teamDirectoryRegisterLogin,
    element: <MemberLogin />,
    isPrivate: false,
  },
  // {
  //   name: "RobotDirectory",
  //   path: pageRoutes.more?.robotDirectory,
  //   element: <RobotDirectory />,
  //   isPrivate: false,
  // },
  {
    name: "Gallery",
    path: pageRoutes.more?.gallery,
    element: <Gallery />,
    isPrivate: false,
  },
  {
    name: "GlossaryOfTerms",
    path: pageRoutes.more?.glossaryOfTerms,
    element: <GlossaryOfTerms />,
    isPrivate: false,
  },
  {
    name: "Login",
    path: pageRoutes.login,
    element: <Login />,
    isPrivate: false,
  },
  {
    name: "MyAccount",
    path: pageRoutes.myAccount,
    element: <MyAccount />,
    isPrivate: true,
  },
  {
    name: "MyOrders",
    path: pageRoutes.myOrders,
    element: <MyOrders />,
    isPrivate: true,
  },
  {
    name: "AddressDetail",
    path: pageRoutes.addressDetail,
    element: <AddressDetail />,
    isPrivate: true,
  },
  {
    name: "Profile",
    path: pageRoutes.profile,
    element: <Profile />,
    isPrivate: true,
  },
  {
    name: "EditProfile",
    path: pageRoutes.editProfile,
    element: <EditProfile />,
    isPrivate: true,
  },
  {
    name: "Products",
    path: pageRoutes?.shop?.products,
    element: <Products />,
    isPrivate: false,
  },
  {
    name: "ProductDetail",
    path: pageRoutes?.shop?.productDetails,
    element: <ProductDetail />,
    isPrivate: false,
  },
  {
    name: "Cart",
    path: pageRoutes?.cart,
    element: <Cart />,
    isPrivate: true,
  },
  {
    name: "Checkout",
    path: pageRoutes?.checkout,
    element: <Checkout />,
    isPrivate: true,
  },
  {
    name: "About",
    path: pageRoutes?.about,
    element: <About />,
    isPrivate: false,
  },
  {
    name: "ForgotPassword",
    path: pageRoutes?.forgotPassword,
    element: <ForgotPassword />,
    isPrivate: false,
  },
  {
    name: "Services",
    path: pageRoutes?.services,
    element: <Services />,
    isPrivate: false,
  },
  {
    name: "ServiceDetail",
    path: pageRoutes?.serviceDetail,
    element: <ServiceDetail />,
    isPrivate: false,
  },
  {
    name: "OrderCancel",
    path: pageRoutes?.shop?.orderCancel,
    element: <OrderCancel />,
    isPrivate: true,
  },
  {
    name: "ThankyouPage",
    path: pageRoutes?.shop?.thankyouPage,
    element: <ThankyouPage />,
    isPrivate: true,
  },
  {
    name: "PrivacyPolicy",
    path: pageRoutes?.privacyPolicy,
    element: <PrivacyPolicy />,
    isPrivate: false,
  },
  {
    name: "ContactUs",
    path: pageRoutes?.contactUs,
    element: <ContactUs />,
    isPrivate: false,
  },
  {
    name: "authcheck",
    path: pageRoutes.authcheck,
    element: <AuthCheck />,
    isPrivate: false,
  },
  {
    name: "Curriculum",
    path: pageRoutes.Curriculum,
    element: <Curriculum />,
    isPrivate: false,
  },
];
